export const QUESTION_LIST = `/question/list`;
export const DOWNLOAD_ALL_QUESTION = `/question/download-all-papers`;
export const DOWNLOAD_ALL_ANSWER = `/question/download-all-answers`;
export const GET_ELECTIVE_BY_SUBJECT_ID = `/question/get-electives/`
export const UPLOAD_ANSWER_BY_SUBJECT_ID = `/question/upload-answer/`
export const SELECT_ELECTIVE_BY_SUBJECT_ID = `/question/select-elective/`
export const UPDATE_LAST_VIEW = `/question/update-last-view/`
export const GET_UPLOAD_ANSWER_DATA = `/question/upload-answer-page/`
export const UPLOAD_ANSWER_PAGE = `/question/upload-answer/`